import {useAuth} from "../../../../hooks/useAuth";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useRouteMatch} from "../../../../utils/functions";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import PageTitle from "../../../../shared/ui/PageTitle";
import GenericButton from "../../../../shared/ui/GenericButton";
import BoxContent from "../../../../shared/ui/BoxContent";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TestsActive from "./TestsActive";
import TestsHistory from "./TestsHistory";
import React from "react";
import {TestTypeConfig} from "../../../../shared/types/testTypes";

interface Props {
    config: TestTypeConfig;
}
const TestsPageTemplate = ({config}: Props) => {
    const {testType, title, addTestPath, tabs} = {
        testType: config.id,
        title: config.name,
        addTestPath: config.addTestPath,
        tabs: config.tabs,
    };
    const {user} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const currentTab = useRouteMatch(tabs.map((tab) => tab.path));
    const theme = useTheme();
    const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

    return (
        <Box>
            <PageTitle
                actions={
                    user.position === "teacher" && (
                        <GenericButton
                            type="generate-test"
                            onClick={() => {navigate(addTestPath)}}
                        />
                    )
                }
            >
                {title}
            </PageTitle>
            <BoxContent>
                <Box sx={{width: "100%"}}>
                    <Box mb={2} sx={{flexGrow: 1,
                        maxWidth: "100%", borderBottom: 1, borderColor: "divider"}}>
                        <Tabs
                            value={currentTab}
                            variant="scrollable"
                            scrollButtons={!isSmUp}
                            allowScrollButtonsMobile
                        >
                            {tabs.map((tab) => (
                                <Tab
                                    key={tab.path}
                                    label={tab.label}
                                    value={tab.path}
                                    to={tab.path}
                                    component={Link}
                                    sx={{color: "secondary.light", "& :hover, & .active": "primary.main"}}
                                />
                            ))}
                        </Tabs>
                    </Box>
                    {tabs[0]?.path && location.pathname === tabs[0].path && <TestsActive type={testType}/>}
                    {tabs[1]?.path && location.pathname === tabs[1].path && <TestsHistory type={testType} tabType="history"/>}
                    {tabs[2]?.path && location.pathname === tabs[2].path && <TestsHistory type={testType} tabType="archives"/>}
                </Box>
            </BoxContent>
        </Box>
    )
}
export default TestsPageTemplate;